import React, { FC } from "react";

import { Stack, Typography } from "@components/base";

const TextFields: FC = () => (
  <Stack spacing={4}>
    <Stack spacing={2}>
      <Typography variant="h1">Header 1</Typography>
      <Typography variant="h2">Header 2</Typography>
      <Typography variant="subtitle1">Subtitle 1</Typography>
      <Typography variant="subtitle2">Subtitle 2</Typography>
      <Typography variant="body1">Body 1 (default)</Typography>
      <Typography variant="caption1">Caption 1</Typography>
      <Typography variant="caption2">Caption 2</Typography>
    </Stack>
  </Stack>
);

export default TextFields;
